import { createEmojiIcon } from '../EmojiIcon';

export const ArrowUpward = createEmojiIcon('↑');
export const ArrowDownward = createEmojiIcon('↓');
export const KeyboardArrowUpIcon = createEmojiIcon('▲');
export const KeyboardArrowDownIcon = createEmojiIcon('▼');
export const ChevronLeftIcon = createEmojiIcon('‹');
/** non-Icon-suffix alias for ChevronLeftIcon */
export const ChevronLeft = createEmojiIcon('‹');
export const ChevronRightIcon = createEmojiIcon('›');
/** non-Icon-suffix alias for ChevronRightIcon */
export const ChevronRight = createEmojiIcon('›');
export const NavigateBeforeIcon = createEmojiIcon('‹');
export const NavigateNextIcon = createEmojiIcon('›');
export const FirstPageIcon = createEmojiIcon('«');
export const LastPageIcon = createEmojiIcon('»');
export const ArrowBackIcon = createEmojiIcon('←');
/** non-Icon-suffix alias for ArrowBackIcon */
export const ArrowBack = createEmojiIcon('←');
export const ArrowForwardIcon = createEmojiIcon('→');
